module.exports = __webpack_public_path__ + "static/media/ssv-proto.02b5ea10.mov";